import { graphql, useStaticQuery } from "gatsby";
import { SiteMetadata } from "../../gatsby-configts";

export const useSiteMetadataVersions = () => {
  const {
    site: {
      siteMetadata: { versions, latestVersion },
    },
  } = useStaticQuery<{
    site: { siteMetadata: Pick<SiteMetadata, "versions" | "latestVersion"> };
  }>(
    graphql`
      query {
        site {
          siteMetadata {
            versions
            latestVersion
          }
        }
      }
    `
  );
  return { versions, latestVersion };
};
